import React from 'react';
import './StatusBar.css';

const MicIcon  = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"/><path d="M19 10v2a7 7 0 01-14 0v-2"/><line x1="12" y1="19" x2="12" y2="23"/><line x1="8" y1="23" x2="16" y2="23"/></svg>;
const WifiIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12.55a11 11 0 0114.08 0"/><path d="M1.42 9a16 16 0 0121.16 0"/><path d="M8.53 16.11a6 6 0 016.95 0"/><circle cx="12" cy="20" r="1" fill="currentColor"/></svg>;
const UsersIcon= () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>;
const MsgIcon  = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>;

const StatusBar = ({ connected, listening, translating, language, users, msgCount }) => {
  const langLabel = language === 'ja-JP' ? 'JA → EN' : 'EN → JA';

  return (
    <div className="status-bar">
      {/* Socket connection */}
      <div
        className={`status-pill ${connected ? 'status-pill--green' : 'status-pill--red'}`}
        data-tip={connected ? 'Server connected' : 'Disconnected'}
      >
        <WifiIcon/>
      </div>

      {/* Speech recognition */}
      <div
        className={`status-pill ${listening ? 'status-pill--orange' : 'status-pill--grey'}`}
        data-tip={listening ? 'Listening…' : 'Mic off'}
      >
        <span className={`status-mic-icon${listening ? ' listening' : ''}`}><MicIcon/></span>
      </div>

      {/* Translating indicator */}
      {translating && (
        <div className="status-pill status-pill--teal" data-tip="Translating…">
          <span className="status-spinner"/>
        </div>
      )}

      {/* Users */}
      <div className="status-pill status-pill--grey" data-tip={`${users} online`}>
        <UsersIcon/>
      </div>

      {/* Message count */}
      <div className="status-pill status-pill--grey" data-tip={`${msgCount} messages`}>
        <MsgIcon/>
        {msgCount > 0 && <span className="status-msg-count">{msgCount}</span>}
      </div>
    </div>
  );
};

export default StatusBar;
